export const API_SERVER_HOST = process.env.REACT_APP_API_SERVER_HOST;
